import { getShipCompanyAndAgent } from "@/api/sh-manifest";
import { getSupportCompanyList, getNodeStatusCodeList } from "@/api/abroad";
import { getHsCodeCategoryTree } from "@/api/analysis";
import { apiCallback } from "@/utils";
import { importTxtDataToJSON } from "@/utils/txtdata";
import { getShipAgent, getShipCompany } from "../../api/sh-manifest";
import { getAllCountryCode } from "@/api/shanghaiManifest";
import { getAllFeiTuoPortCode } from "@/api/shipSchedule";

const state = {
    documentsAttachedList: [], // 监管条件（随附单证）
    shipCompany: [], // 船公司列表（海管家获取）
    shipAgent: [], // 船代列表（海管家获取）
    hscodeCategory: [], // hscode类目数据
    supportShipCompany: [], // 海外运踪支持的船公司
    assistant: {
        supvModeCdde: [], // 监管方式
        shippingTypeList: [], //运输方式
        countryList: [], // 国家
        currencySystemList: [], //币制
        exitCustomsList: [], // 出境关别
        preDecContainerVo: [], // 集装箱
        transMethodList: [], // 成交方式
        packingList: [], // 包装种类
        destinationPortList: [], // 指运港
        departurePortList: [], // 离境口岸
        countryNumList: [], // 国家数字
        countryEnList: [], // 国家英文
        destinationPortEnList: [], // 指运港英文
        documentsAttachedList: [], // 监管条件
        unitList: [], // 单位
        // 国家code对应中文
        countryCodeToName: {},
        // 国家code对应数字
        countryCodeToNum: {},
        // 港口code对应中文
        portCodeToName: {},
    },
    abroad: {
        nodeStatusCodeList: [], // 节点状态code列表
        nodeDescEnum: {}, // 节点状态code枚举 格式：{code: description}
    },
    shipSchedule: {
        countryList: [], // 国家列表
        countryCodeEnum: {}, // 国家code枚举 格式：{code: name}
        feiTuoPortCodeList: [], // 飞陀港口代码列表
        feiTuoPortCodeEnum: {}, // 飞陀港口代码枚举 格式：{port: {portNameCn:xxx.portName:xxx}}
    },
};

const mutations = {
    editDocumentsAttachedList(state, payload) {
        state.documentsAttachedList = payload.documentsAttachedList;
    },
    editShipAgent(state, payload) {
        state.shipAgent = payload;
    },
    editShipCompany(state, payload) {
        state.shipCompany = payload;
    },
    editHscodeCategory(state, payload) {
        state.hscodeCategory = payload;
    },
    editSupportShipCompany(state, payload) {
        state.supportShipCompany = payload;
    },
    changeTxtData(state, payload) {
        state.assistant = payload;
        // 国家code对应数字
        const countryNumEnum = {};
        // 国家code对应中文
        const countryNameEnum = {};
        // 港口code对应中文
        const portCodeToNameEnum = {};
        const numObj = {};
        const { countryNumList, countryList, destinationPortList } = payload;
        countryNumList.forEach((item) => {
            numObj[item.label] = item.value;
        });
        countryList.forEach((item) => {
            countryNumEnum[item.value] = numObj[item.label];
            countryNameEnum[item.value] = item.label;
        });
        destinationPortList.forEach((item) => {
            portCodeToNameEnum[item.value] = item.label;
        });
        state.assistant.countryCodeToNum = countryNumEnum;
        state.assistant.countryCodeToName = countryNameEnum;
        state.assistant.portCodeToName = portCodeToNameEnum;
    },
    editNodeStatusCodeList(state, payload) {
        state.abroad.nodeStatusCodeList = payload;
    },
    editNodeDescEnum(state, payload) {
        state.abroad.nodeDescEnum = payload;
    },
    editShipScheduleCountryList(state, payload) {
        state.shipSchedule.countryList = payload;
        state.shipSchedule.countryCodeEnum = payload.reduce((acc, item) => {
            acc[item.code] = item.name;
            return acc;
        }, {});
    },
    editFeiTuoPortCodeList(state, payload) {
        state.shipSchedule.feiTuoPortCodeList = payload;
        state.shipSchedule.feiTuoPortCodeEnum = payload.reduce((acc, item) => {
            acc[item.port] = {
                portNameCn: item.portNameCn,
                portName: item.portname,
                country: item.country,
                countryEn: item.countryEn,
            };
            return acc;
        }, {});
    },
};

const actions = {
    updateSupportShipCompany({ commit }) {
        return new Promise((resolve) => {
            getSupportCompanyList().then((res) => {
                const data = apiCallback(res);
                let list = [];
                if (typeof data === "string") {
                    list = JSON.parse(data).data.list;
                } else {
                    list = data?.list || [];
                }
                if (list.length > 0) {
                    commit("editSupportShipCompany", list);
                }
                resolve(list);
            });
        });
    },
    updateDocumentsAttachedList({ commit }) {
        return new Promise((resolve) => {
            importTxtDataToJSON().then((res) => {
                commit("editDocumentsAttachedList", res);
                resolve();
            });
        });
    },
    updateShipCompanyAndAgent({ commit }) {
        return new Promise((resolve) => {
            getShipCompanyAndAgent().then((res) => {
                const { shipAgency, shipCompany } = apiCallback(res);
                const cacheShipAgency = shipAgency.map((item) => {
                    return {
                        label: item.dictKey,
                        value: item.id,
                    };
                });
                const cacheShipCompany = shipCompany.map((item) => {
                    return {
                        label: item.dictKey,
                        value: item.id,
                    };
                });
                commit("editShipAgent", cacheShipAgency);
                commit("editShipCompany", cacheShipCompany);
                resolve(res);
            });
        });
    },
    updateShipAgent({ commit }) {
        return new Promise((resolve) => {
            getShipAgent().then((res) => {
                const data = apiCallback(res);
                const shipAgent = data.map((item) => {
                    return {
                        label: item.dictKey,
                        value: item.id,
                    };
                });
                commit("editShipAgent", shipAgent);
                resolve(res);
            });
        });
    },
    updateShipCompany({ commit }) {
        return new Promise((resolve) => {
            getShipCompany().then((res) => {
                const data = apiCallback(res);
                const shipCompany = data.map((item) => {
                    return {
                        label: item.dictKey,
                        value: item.id,
                    };
                });
                commit("editShipCompany", shipCompany);
                resolve(res);
            });
        });
    },
    updateHscodeCategoryData({ commit }) {
        return new Promise((resolve) => {
            getHsCodeCategoryTree().then((res) => {
                const data = apiCallback(res);
                commit("editHscodeCategory", data);
                resolve(data);
            });
        });
    },
    updateNodeStatusCodeList({ commit }, payload) {
        return new Promise((resolve) => {
            getNodeStatusCodeList(payload && payload?.token).then((res) => {
                const data = apiCallback(res);
                // console.log(data,'data')
                let list = [];
                if (typeof data === "string") {
                    list = JSON.parse(data).data.list;
                } else {
                    list = data?.list || [];
                }
                if (list.length > 0) {
                    const cacheEnum = list.reduce((acc, item) => {
                        acc[item.code] = item.description;
                        return acc;
                    }, {});
                    commit("editNodeStatusCodeList", list);
                    commit("editNodeDescEnum", cacheEnum);
                    resolve(list);
                } else {
                    resolve([]);
                }
            });
        });
    },
    updateShipScheduleCountryList({ commit }) {
        return new Promise((resolve) => {
            getAllCountryCode()
                .then((res) => {
                    const data = apiCallback(res);
                    commit("editShipScheduleCountryList", data);
                    resolve(data);
                })
                .finally(() => {
                    resolve([]);
                });
        });
    },
    updateFeiTuoPortCodeList({ commit }) {
        return new Promise((resolve) => {
            getAllFeiTuoPortCode().then((res) => {
                const data = apiCallback(res);
                commit("editFeiTuoPortCodeList", data);
                resolve(data);
            });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
